import { Button } from '@common/components';
import { SvgHandHeldWriting, SvgInstagram, SvgPlaylist } from '@common/icon';

export const BusinessInfo = () => {
  return (
    <div className="flex flex-col">
      <p className="pb-8 font-700 text-Gray-600 typo-body4">주식회사 웰로</p>
      <ul className="flex flex-col gap-4 pb-8 font-400 text-Gray-600 typo-body4">
        <li>대표 : 김유리안나</li>
        <li className="pointer-events-none">사업자등록번호 : 705-86-02126</li>
        <li>
          통신판매업신고번호&nbsp;
          <a
            className="underline"
            href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126"
            target="_blank"
            rel="noreferrer external"
          >
            제2024-세종아름-0756호
          </a>
        </li>
        <li>
          <address className="not-italic">
            서울오피스: 서울특별시 관악구 남부순환로 1933, JW타워
          </address>
        </li>
        <li>
          <address className="not-italic">
            세종오피스: 세종특별자치시 가름로 232, 세종비지니스센터
          </address>
        </li>
        <li className="flex items-center gap-8">
          <a className="underline" href="mailto:cs@wello.info">
            cs@wello.info
          </a>
          <div className="h-10 w-1 bg-Gray-300" />
          <a href="tel:1833-9363">1833-9363</a>
        </li>
      </ul>
      <ul className="flex items-center gap-4">
        <li>
          <Button
            theme="sub-line"
            dimensions="H26"
            asChild
            className="bg-Gray-white"
          >
            <a
              aria-label="인스타그램에서 웰로 팔로우하기"
              href="https://www.instagram.com/wello.info"
              rel="noreferrer"
              target="_blank"
              className="flex gap-4 text-Gray-black"
            >
              인스타그램
              <SvgInstagram className="size-10 text-Gray-black" />
            </a>
          </Button>
        </li>
        <li>
          <Button
            theme="sub-line"
            dimensions="H26"
            asChild
            className="bg-Gray-white"
          >
            <a
              aria-label="유튜브에서 웰로 구독하기"
              href="https://www.youtube.com/@wello_info"
              rel="noreferrer"
              target="_blank"
              className="flex gap-4 text-Gray-black"
            >
              유튜브
              <SvgPlaylist className="size-10 text-Gray-black" />
            </a>
          </Button>
        </li>
        <li>
          <Button
            theme="sub-line"
            dimensions="H26"
            asChild
            className="bg-Gray-white"
          >
            <a
              aria-label="네이버 블로그에서 웰로 방문하기"
              href="https://blog.naver.com/wello_official"
              rel="noreferrer"
              target="_blank"
              className="flex gap-4 text-Gray-black"
            >
              블로그
              <SvgHandHeldWriting className="size-10 text-Gray-black" />
            </a>
          </Button>
        </li>
      </ul>
    </div>
  );
};
